import { Link } from "react-router-dom";
import { Phone, Mail, Globe, MapPin, FileDown } from "lucide-react";
import { useContent } from "@/lib/content";

const show = (v) => v ?? "Em atualização";

export const SiteFooter = () => {
  const { company: COMPANY } = useContent();
  return (
  <footer data-testid="site-footer" className="relative grain bg-[#0B192C] text-white overflow-hidden">
    <div className="pointer-events-none absolute bottom-0 left-1/3 h-[260px] w-[520px] rounded-full bg-amber-500/10 blur-[120px]" />
    <div className="relative max-w-7xl mx-auto px-5 sm:px-8 py-16">
      <div className="grid md:grid-cols-4 gap-10">
        <div>
          <img
            src="/logo-hb-solar.png"
            alt="HB Solar — Soluções Sustentáveis"
            className="h-14 w-auto rounded-xl bg-white px-2 py-1"
          />
          <p className="mt-4 text-sm leading-relaxed text-slate-400">
            Soluções energéticas completas: geração solar e infraestrutura de
            recarga para veículos elétricos, do projeto à operação.
          </p>
          <p className="mt-3 text-xs font-bold uppercase tracking-[0.2em] text-amber-400">
            HB Solar · HB Charger
          </p>
        </div>

        <div>
          <p className="text-xs font-bold uppercase tracking-[0.22em] text-amber-400 mb-5">Institucional</p>
          <ul className="space-y-3 text-sm text-slate-300">
            <li><Link className="hover:text-amber-300 transition-colors" to="/carregadores">Carregadores</Link></li>
            <li><Link className="hover:text-amber-300 transition-colors" to="/solucoes">Soluções</Link></li>
            <li><Link className="hover:text-amber-300 transition-colors" to="/projeto-instalacao">Projetos e Instalação</Link></li>
            <li><Link className="hover:text-amber-300 transition-colors" to="/plataforma">Plataforma</Link></li>
            <li><Link className="hover:text-amber-300 transition-colors" to="/sobre">Sobre nós</Link></li>
            <li><Link className="hover:text-amber-300 transition-colors" to="/contato">Contato</Link></li>
          </ul>
        </div>

        <div>
          <p className="text-xs font-bold uppercase tracking-[0.22em] text-amber-400 mb-5">Documentos</p>
          <ul className="space-y-3 text-sm text-slate-300">
            <li>
              <a
                data-testid="footer-catalog-download"
                href="/catalogo-hb-charger.pdf"
                download
                className="inline-flex items-center gap-2 hover:text-amber-300 transition-colors"
              >
                <FileDown className="h-4 w-4 text-amber-400" />
                Catálogo de Carregadores (PDF)
              </a>
            </li>
            <li>
              <Link
                data-testid="footer-responsabilidades-link"
                className="hover:text-amber-300 transition-colors"
                to="/responsabilidades-tecnicas"
              >
                Responsabilidades e Condições Técnicas
              </Link>
            </li>
            <li><Link className="hover:text-amber-300 transition-colors" to="/simule">Simule seu projeto</Link></li>
            <li>
              <Link
                data-testid="footer-admin-link"
                className="hover:text-amber-300 transition-colors"
                to="/admin/login"
              >
                Acesso restrito
              </Link>
            </li>
          </ul>
        </div>

        <div>
          <p className="text-xs font-bold uppercase tracking-[0.22em] text-amber-400 mb-5">Contato</p>
          <ul className="space-y-3.5 text-sm text-slate-300">
            <li className="flex items-center gap-3">
              <Phone className="h-4 w-4 text-amber-400 shrink-0" /> {COMPANY.telefone}
            </li>
            <li className="flex items-center gap-3">
              <Mail className="h-4 w-4 text-amber-400 shrink-0" /> {COMPANY.email}
            </li>
            <li className="flex items-center gap-3">
              <Globe className="h-4 w-4 text-amber-400 shrink-0" /> {COMPANY.dominio}
            </li>
            <li className="flex items-start gap-3">
              <MapPin className="h-4 w-4 text-amber-400 shrink-0 mt-0.5" />
              <span>
                {show(COMPANY.endereco)}
                <br />
                <span className="text-slate-500">{COMPANY.regioes}</span>
              </span>
            </li>
            <li className="text-xs text-slate-500">CNPJ: {show(COMPANY.cnpj)}</li>
          </ul>
        </div>
      </div>

      <div className="mt-14 border-t border-white/10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
        <p className="text-xs text-slate-500">
          © {new Date().getFullYear()} HB Solar — {COMPANY.dominio}. Todos os direitos reservados.
        </p>
        <p className="text-xs font-semibold text-slate-500 uppercase tracking-[0.2em]">
          Energia solar · Mobilidade elétrica
        </p>
      </div>
    </div>
  </footer>
  );
};
